import { styled } from 'styled-components';

export const IconWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  margin: 30px 0;
  margin-bottom: 20px;
  color: var(--pcm-accent-color);
`;

export const TipText = styled.div`
  text-align: center;
  font-size: 14px;
  color: var(--pcm-body-color);
  margin-top: 16px;
  margin-bottom: 40px;
`;
